import { Component, h, Prop, Host, Watch, Element } from '@stencil/core';
import { checkSlottedContentForInvalidHTML } from '../../../global/utils/utils';
/**
 * @slot - Name = validation-text. The contents of this slot is the validation text.
 * @slot - Name = hint-text. The contents of this slot is the hint text.
 * Note that the component will toggle between the hint and error texts based on the error state
 */
export class HintValidationMessageComponent {
  constructor() {
    /**
     * The id of the validation text used mainly for accessability.
     */
    this.asDescribedbyId = '';
    /**
     * show or hide the validation message.
     */
    this.hasError = false;
  }
  valueWatchHandler(hasError) {
    if (this.hintDiv && this.hintDiv.children[0]) {
      this.hintDiv.children[0].hidden = hasError;
    }
    if (this.validationDiv && this.validationDiv.children[0]) {
      this.validationDiv.children[0].hidden = !hasError;
    }
  }
  componentWillLoad() {
    checkSlottedContentForInvalidHTML(this.host.querySelector('[slot="hint-text"]'), ['div', 'agl-ds-text', 'agl-ds-link']);
    checkSlottedContentForInvalidHTML(this.host.querySelector('[slot="validation-text"]'), ['div', 'agl-ds-text', 'agl-ds-link']);
  }
  componentDidLoad() {
    this.valueWatchHandler(this.hasError);
  }
  render() {
    if (this.asDescribedbyId === '') {
      throw new Error('This component requires an message id');
    }
    return (h(Host, null,
      h("div", { class: "message-container" },
        h("div", { ref: (el) => (this.hintDiv = el), id: !this.hasError === true ? this.asDescribedbyId : null, class: {
            'message-container__hint-text-section': true,
            hidden: this.hasError
          } },
          h("slot", { name: "hint-text" })),
        h("div", { ref: (el) => (this.validationDiv = el), id: this.hasError === true ? this.asDescribedbyId : null, class: {
            'message-container__validation-text-section': true,
            hidden: !this.hasError
          }, role: "alert" },
          h("slot", { name: "validation-text" })))));
  }
  static get is() { return "agl-ds-hint-validation-message"; }
  static get originalStyleUrls() { return {
    "$": ["hint-validation-message.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["hint-validation-message.component.css"]
  }; }
  static get properties() { return {
    "asDescribedbyId": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "The id of the validation text used mainly for accessability."
      },
      "attribute": "as-describedby-id",
      "reflect": false,
      "defaultValue": "''"
    },
    "hasError": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "show or hide the validation message."
      },
      "attribute": "has-error",
      "reflect": false,
      "defaultValue": "false"
    }
  }; }
  static get elementRef() { return "host"; }
  static get watchers() { return [{
      "propName": "hasError",
      "methodName": "valueWatchHandler"
    }]; }
}
